module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-700-bold-italic-3c36033ac91e54d1b3149398594b6c87.woff";